import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Logger from '@/lib/Logger'

class App {
  static find({ get, by, onChange, onError }) {
    Logger.debug('App.find', get)
    // if (!by.id) {
    //   throw new Error('Called App.find with void "by.id"')
    // }
    try {
      return GqlClient.activeQuery({
        retrieveGql: {
          dataKey: 'appGet',
          query: gql`
          query appGet {
            appGet
                ${get}
          }`,
          // variables: {},
        },
        listenGql: {
          dataKey: 'AppChanged',
          query: gql`
          subscription {
            appChanged
              ${get}
          }`,
        },
        onDataChange: data => {
          Logger.debug('New App DATA:', get, by, data)
          onChange(data)
        },
        onError: error => onError(error),
      })
    } catch (e) {
      Logger.error(e)
    }
  }
}

export default App
